import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrModalV2 from 'client/components/SrModalV2/SrModalV2';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrIcon from 'client/components/SrIcon';
import SrFlex from 'client/components/SrFlex';

const SrPartnerStatInfoModal = ({
  onClose,
  title,
  text,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrModalV2
      centerContent
      closeOnBackgroundClick
      showCloseButton={false}
      contentMaxWidth={!isSmallScreen ? '400px' : null}
      onClose={onClose}
    >
      <SrBox
        width='100%'
        marginBottom='100px'
        onClick={onClose}
      >
        <SrBox>
          <SrFlex justify='center'>
            <SrIcon className='question-mark-circle-large' />
          </SrFlex>
          <SrBox
            marginTop='20px'
            marginBottom='26px'
          >
            <SrText
              color='white'
              font='greycliff'
              fontSize='32px'
              weight='800'
              align='center'
              display='block'
            >
              {title}
            </SrText>
          </SrBox>
          <SrBox
            borderRadius='14px'
          >
            <SrBox
              padding='0 16px'
              boxSizing='border-box'
            >
              <SrText
                color='white'
                font='greycliff'
                size='21'
                lineHeight='30px'
                align='center'
                weight='500'
                display='block'
              >
                {text}
              </SrText>
            </SrBox>
          </SrBox>
        </SrBox>
      </SrBox>
    </SrModalV2>
  );
};

SrPartnerStatInfoModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

SrPartnerStatInfoModal.displayName = 'SrPartnerStatInfoModal';

export default SrPartnerStatInfoModal;
